// extracted by mini-css-extract-plugin
export var deleteModal = "_ij-0";